import { Css, useTestIds } from "@homebound/beam";
import { ReactNode } from "react";
import { getCompanyInfoField } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/utils/companyInfoUtils";
import { TradePartnerSignatoryContactFragment } from "src/routes/pdfs/components/CommitmentAddresses.generated";
import { fail } from "src/utils";
import { CompanyInfoFieldFragment } from "../CommitmentOrChangeOrderPdf/utils/companyInfoUtils.generated";

type CommitmentAddressesProps = {
  tradePartner: { name: string; id: string };
  signatoryContact: TradePartnerSignatoryContactFragment;
  project?: CompanyInfoFieldFragment;
  children?: ReactNode;
};

/** Shows the Homebound address (with region-specific info) and the TP address side-by-side. */
export function CommitmentAddresses({ tradePartner, signatoryContact, project, children }: CommitmentAddressesProps) {
  const address = signatoryContact.address || fail(`${signatoryContact.name} does not have an address`);
  const tid = useTestIds({});

  return (
    <div css={Css.df.fdr.mt2.$}>
      <div css={Css.df.f1.fdc.p1.wPx(562).$}>
        <div css={Css.fwb.$}>{getCompanyInfoField(project, "name")}</div>
        <div>1875 Mission St. Ste 103, #257</div>
        <div>San Francisco, CA 94103</div>
        <div>{getCompanyInfoField(project, "licenseNumber")}</div>
      </div>

      {tradePartner && (
        <div css={Css.df.f1.fdc.p1.wPx(562).$}>
          <div {...tid.tradePartnerName} css={Css.fwb.$}>
            {tradePartner.name}
          </div>
          <div>{signatoryContact.name}</div>
          <div>
            {address.street1} {address.street2}
          </div>
          <div>
            {address.city}, {address.state} {address.postalCode} {address.country}
          </div>
          <div>Email: {signatoryContact.email}</div>
          <div>Phone: {signatoryContact.officePhone || signatoryContact.mobilePhone}</div>
        </div>
      )}

      {children}
    </div>
  );
}
